import Course from '../../../api/Course';
import * as types from './mutation-types';

export const show = async ({ commit }, { id }) => {
    const json = await new Course().show(id);

    commit(types.COURSE, json);
};

export const getCourseMap = async ({ commit }, { id }) => {
    const json = await new Course().getCourseMap(id);

    return json.data;
};

export default {
    show,
    getCourseMap,
};



// WEBPACK FOOTER //
// ./src/store/modules/course/actions.js